import axios from "axios";
import firebase from "config/firebase";
import { toast } from "react-toastify";

export const getFans = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .where("role", "==", "fan")
      .limit(100)
      .onSnapshot((query) => {
        var fans = [];
        query.forEach((doc) => {
          fans.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_FANS",
          payload: fans,
        });
      });
  };
};

export const getFansRequests = (uid, lastDocument, onSuccess) => {
  return async (dispatch) => {
    try {
      let querya = firebase
        .firestore()
        .collection("fan_requests")
        .where("athlete_id", "==", uid)
        .orderBy("created_at", "desc");
      if (lastDocument !== "") {
        querya = querya.startAfter(lastDocument);
      }
      querya = querya.limit(5);
      const unsubscribe = querya.onSnapshot(async (snapshot) => {
        let temp_data = [];
        for (const doc of snapshot.docs) {
          const docData = doc.data();
          const enrolledSnapShot = await firebase
            .firestore()
            .collection("users")
            .doc(docData.fan_id)
            .get();

          temp_data.push({
            id: doc.id,
            ...docData,
            fanData: enrolledSnapShot.data(),
          });
        }
        dispatch({
          type: lastDocument ? "GET_FANS_REQUESTS_MORE" : "GET_FANS_REQUESTS",
          payload: {
            data: temp_data,
            lastDocument: snapshot.docs[temp_data.length - 1] || null,
            hasMoreDocument: temp_data.length >= 5,
          },
        });
        onSuccess();
      });
      return unsubscribe;
    } catch (error) {
      console.error("Error getting fan requests: ", error);
      dispatch({ type: "GET_CONTEST_ERROR", payload: error.message });
      onSuccess();
    }
  };
};

export const updateFanRequest = (id, status, onSuccess) => async (dispatch) => {
  try {
    firebase.firestore().collection("fan_requests").doc(id).update({ status });
    onSuccess();
  } catch (error) {
    console.error(error);
  }
};
export const deleteFanRequest = (id, onSuccess) => {
  return async (dispatch) => {
    try {
      firebase.firestore().collection("fan_requests").doc(id).delete();
      onSuccess();
    } catch (error) {
      console.error(error);
    }
  };
};
export const getLicensePurchases = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("license_purchases")
      .where("athlete_id", "==", id)
      .onSnapshot((query) => {
        var licenses = [];
        query.forEach((doc) => {
          licenses.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_LICENSES",
          payload: licenses,
        });
      });
  };
};
export const getSubscriptionEarning = (id) => {
  return async (dispatch) => {
    dispatch(subscriptionLoading(true));
    var users = [];
    var data = [];
    var finalData = [];
    var accessToken;
    var totalAmount;
    let subscriptionsData = await firebase
      .firestore()
      .collection("license_subscriptions")
      .where("athlete_id", "==", id)
      .limit(100) // A-028: Limit unbounded query
      .get();

    // Call backend endpoint to fetch earnings instead of fetching from PayPal on client
    // Replace with actual repository call once backend function is ready
    /*
    const response = await repository.get('/paypal-earnings');
    totalAmount = response.data.totalAmount;
    */
    totalAmount = 0; // Placeholder until backend is implemented

    for (let doc of subscriptionsData.docs) {
      let halfAmount = Number(doc.data().amount?.value) / 2;
      var session_url2 = `https://api-m.sandbox.paypal.com/v1/billing/subscriptions/${
        doc.data().subscription_id
      }`;
      await axios
        .get(session_url2, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => {
          totalAmount =
            response.data.billing_info.cycle_executions[0].cycles_completed *
            halfAmount;
          users.push({
            athlete_id: doc.data()?.athlete_id,
            amount: totalAmount,
          });
        })
        .catch((error) => {
          console.error("Error in Subscription ", error.message);
        });
    }
    await firebase
      .firestore()
      .collection("users")
      .get()
      .then((query) => {
        for (let doc of query.docs) {
          data.push({
            id: doc.id,
            ...doc.data(),
          });
        }
      });
    users?.map((val) => {
      let obj = data?.find((v) => v.id == val.athlete_id);
      let check = finalData?.find((v) => v.id == val.athlete_id);
      if (obj && !check) {
        finalData.push({
          id: obj?.id,
          athleteID: obj?.athleteID,
          name: obj?.first_name + " " + obj?.last_name,
          email: obj?.email,
          amount: val?.amount,
          created_at: obj?.created_at,
        });
      } else if (check) {
        let idx = finalData?.indexOf(check);
        finalData[idx].amount += val?.amount;
      }
    });
    dispatch(subscriptionLoading(false));
    dispatch({
      type: "GET_EARNING_SUBSCRIPTION_BY_ID",
      payload: finalData,
    });
  };
};

export const getChatEarningByAthleteID = (id) => {
  return async (dispatch) => {
    dispatch(chatEarningLoading(true));

    let val = 0;
    let chatEarningData = await firebase
      .firestore()
      .collection("a4b_chat")
      .where("athleteID", "==", id)
      .where("athlete_payment", "==", true)
      .get();
    for (let doc of chatEarningData.docs) {
      val += (Number(doc.data()?.paid_amount.value) / 100) * 76;
    }
    dispatch({
      type: "GET_CHAT_EARNING_BY_ID",
      payload: val,
    });
    dispatch(chatEarningLoading(false));
  };
};
export const subscriptionLoading = (val) => async (dispatch) => {
  dispatch({ type: "SUBSCRIPTION_LOADING", payload: val });
};

export const chatEarningLoading = (val) => async (dispatch) => {
  dispatch({ type: "CHAT_EARNING_LOADING", payload: val });
};
